/**
 * AuditLogDetailPage — 审计日志详情（只读）
 * 审计日志不可编辑/删除，仅展示完整信息。
 */
import { useParams, useLocation } from 'react-router-dom'
import {
  Text,
} from '@fluentui/react-components'
import { HistoryRegular } from '@fluentui/react-icons'
import { auditLogsApi } from '@/api/audit-logs'
import type { AuditLog } from '@/api/types'
import DetailLayout, { DetailSection, DetailRow } from '@/components/DetailLayout'
import { useDetailItem } from '@/hooks/useDetailItem'
import { formatDate } from '@/lib/format'

export default function AuditLogDetailPage() {
  const { id } = useParams()
  const location = useLocation()

  const { item, isLoading } = useDetailItem<AuditLog>(
    ['audit-logs', 100],
    () => auditLogsApi.list(100),
    id as string,
    'id',
  )

  const stateItem = (location.state as { item?: AuditLog } | null)?.item

  return (
    <DetailLayout
      title={item?.action ?? stateItem?.action ?? '审计日志'}
      subtitle="审计日志详情"
      media={<HistoryRegular fontSize={22} />}
      loading={isLoading && !stateItem}
      notFound={!isLoading && !item && !stateItem}
      notFoundText="未找到该审计日志"
    >
      <DetailSection title="日志详情">
        <DetailRow label="ID" value={item?.id ?? stateItem?.id} />
        <DetailRow label="操作" value={item?.action ?? stateItem?.action} />
        <DetailRow label="操作者" value={item?.actor ?? stateItem?.actor} />
        <DetailRow label="目标" value={item?.target ?? stateItem?.target} />
        <DetailRow
          label="详情"
          value={item?.detail ?? stateItem?.detail}
          full
        />
        <DetailRow label="IP 地址" value={item?.ip_addr ?? stateItem?.ip_addr} />
        <DetailRow label="时间" value={formatDate((item ?? stateItem)?.created_at)} />
      </DetailSection>

      <Text
        style={{
          display: 'block',
          marginTop: '16px',
          fontSize: '12px',
          color: 'var(--colorNeutralForeground3, #8a8886)',
        }}
      >
        审计日志为只读记录，不支持编辑或删除。
      </Text>
    </DetailLayout>
  )
}
